import { styled, useStyletron } from "baseui";
import { getStripeId } from "../../services/resourceGroups/utils";
import { useGetStripeSubscriptionByIdQuery } from "../../services/resourceGroups/subscriptionApi";
import { Badge, COLOR } from "baseui/badge";
import { LoadingView } from "../../components/LoadingView";
import { ISubscription } from "@oqdo/automationapps/Memberships/Subscription";
import { getMergedProducts } from "./utils";

const SubscriptionPaymentDetails = (props: { subscription: ISubscription }) => {
  const [css, theme] = useStyletron();
  const { subscription } = props;
  const stripeId = getStripeId(subscription);
  const products = subscription?.products;
  const {
    data: stripeSubscription,
    isLoading,
    isSuccess,
    error,
  } = useGetStripeSubscriptionByIdQuery(stripeId, { skip: !stripeId });

  const mergedProducts = getMergedProducts(products, stripeSubscription?.products);

  return (
    <LoadingView isSucess={isSuccess || !stripeId} isLoading={isLoading} lines={1} error={undefined}>
      <ItemsContainer>
        {mergedProducts.map(([key, value]) => (
          <Item key={key} item={[key, value.val1]} stripeValue={value.val2} />
        ))}
      </ItemsContainer>
    </LoadingView>
  );
};

export default SubscriptionPaymentDetails;

const Item: React.FC<{
  item: [string, number];
  stripeValue?: number;
}> = (props) => {
  const { item, stripeValue } = props;
  const [css, theme] = useStyletron();

  const itemKey = item[0];
  const itemValue = item[1] ?? 0;
  const paidValue = stripeValue ?? 0;
  return (
    <>
      {itemKey.replaceAll("_", ".")}

      <Badge
        shape="pill"
        content={
          <>
            {itemValue} / {paidValue}
          </>
        }
        hierarchy="secondary"
        color={paidTagColor(itemValue, paidValue)}
      />
    </>
  );
};

function paidTagColor(used: number, paid: number) {
  if (used && !paid) return COLOR.negative;
  if (used > paid) return COLOR.negative;
  if (used === paid) return COLOR.positive;
  if (used < paid) return COLOR.accent;
  return COLOR.primary;
}

const ItemsContainer = styled("div", ({ $theme }) => ({
  display: "flex",
  flexDirection: "row",
  marginTop: $theme.sizing.scale200,
  gap: $theme.sizing.scale200,
}));
